import { render, staticRenderFns } from "./JobDetailsMob.vue?vue&type=template&id=e06ccb22"
import script from "./JobDetailsMob.vue?vue&type=script&lang=js"
export * from "./JobDetailsMob.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsMob.vue?vue&type=style&index=0&id=e06ccb22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports